import AboutPrivacy from './AboutPrivacy.vue'

export default AboutPrivacy
